import React from 'react';
import OfficialPage from '../OfficialPage';
import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams } from '@utils/tools';
import './RechargeIntegral.less';

export default class RechargeIntegral extends OfficialPage {
  state = {
    type: '', // 1:购买充值项
    itemList: [],
    selectedItem: {
      index: -1,
      id: '',
      price: 0,
    },
    customItemInfo: {
      status: 0,
      tip: ''
    },
    customPrice: '',
    couponItemList: [],
    selectedCouponItem: {
      index: -1,
      id: ''
    },
    isPaying: false,
    storedId: 0
  }
  constructor(porps) {
    super(porps);
    document.title = '积分充值';
  }
  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      storedId: options.storedId || 0
    });
    this.getIntegralDetailData();
    this.getItemInfo();
  }
  // 获取当前积分
  getIntegralDetailData = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetIntegralInfo',
      hideLoading: true,
      success: function(res) {
        that.setData({
          canUseIntegral: res.data.can_use_integral
        })
      }
    })
  }
  // 获取AI积分配置
  getItemInfo = () => {
    let that = this
    let param = {
      app_id: app.getAppId()
    }
    app.sendRequest({
      url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
      data: param,
      hideLoading: true,
      success: function(res) {
        if (res.data.length != 0) {
          that.setData({
            type: 1,
            itemList: that.parseItemData(res.data),
            'selectedItem.index': 0,
            'selectedItem.id': res.data[0].id,
          })
          that.defaultSelect(that.data.itemList)
        } else if (res.data.length == 0) {
          that.setData({
            type: 1,
            'selectedItem.index': -1
          })
        }
        that.setData({
          // customItemInfo: that.parseCustomItemData(res.stored_custom_info),
        })
      }
    })
  }
  // 解析充值项数据
  parseItemData = data => {
    let array = []
    let item = {}
    for (var i = 0; i < data.length; i++) {
      item = {}
      item.id = data[i].id
      item.rechargeMoney = Number(data[i].price)
      item.rechargeNum = Number(data[i].num)
      array.push(item)
    }
    return array
  }
  // 选中充值项
  selectActiveItem = event => {
    let that = this
    let index = event.currentTarget.dataset.index
    that.setData({
      type: 1,
      'selectedItem.index': index,
      'selectedItem.id': that.data.itemList[index].id,
      'selectedItem.price': that.data.itemList[index].rechargeMoney,
    })
  }
  // 解析自定义储值数据
  // parseCustomItemData = data => {
  //   return (function(object) {
  //     object = data
  //     if (data.type == 1) {
  //       object['tip'] = '按充值金额x' + data.value + '比例赠送储值金'
  //     } else if (data.type == 2) {
  //       object['tip'] =
  //         '每充值' + data.condition + '元，赠送' + data.value + '元'
  //     } else {
  //       object['tip'] = ''
  //     }
  //     return object
  //   })({})
  // }
  // 选中自定义金额
  // selectCustomItem = () => {
  //   let that = this
  //   that.setData({
  //     type: 6
  //   })
  // }
  // 确定自定义金额
  // confirmCustomPrice = e => {
  //   let that = this
  //   let price = e.target.value
  //   let customItemInfo = that.data.customItemInfo
  //   let tip = ''
  //   if (price == '') {
  //     if (customItemInfo.type == 1) {
  //       tip = '按充值金额x' + customItemInfo.value + '比例赠送储值金'
  //     } else if (customItemInfo.type == 2) {
  //       tip =
  //         '每充值' +
  //         customItemInfo.condition +
  //         '元，赠送' +
  //         customItemInfo.value +
  //         '元'
  //     } else {
  //       tip = ''
  //     }
  //   } else if (!/^[0-9]+([.]{1}[0-9]{1,2})?$/.test(price)) {
  //     tip = '充值的金额必须>=0，精确到小数点后2位!'
  //   } else {
  //     if (customItemInfo.type == 1) {
  //       tip = '赠送储值金' + (price * customItemInfo.value).toFixed(2) + '元'
  //     } else if (customItemInfo.type == 2) {
  //       tip =
  //         '赠送储值金' +
  //         (
  //           Math.floor(price / customItemInfo.condition) * customItemInfo.value
  //         ).toFixed(2) +
  //         '元'
  //     } else {
  //       tip = ''
  //     }
  //   }
  //   that.setData({
  //     customPrice: e.target.value,
  //     'customItemInfo.tip': tip
  //   })
  // }
  // 充值按钮
  payLoading = false
  // 去充值
  gotoRecharge = () => {
    let that = this
    let type = that.data.type
    if (type == 1 && that.data.selectedItem.index == -1) {
      if (that.data.selectedItem.id == '') {
        return false
      }
      app.showToast({
        title: '商家尚未建立充值项',
        icon: 'loading',
        success: function() {}
      })
      return false
    }
    let param = {
      app_id: app.getAppId(),
      integral_config_id: +this.state.selectedItem.id,
      goods_type: 17,
    }
    if (that.payLoading) {
      return
    }
    this.setIsPaying(true)
    app.sendRequest({
      url: '/index.php?r=ChatAI/CreateOrder',
      data: param,
      hideLoading: true,
      method: 'POST',
      success: function(res) {
        let orderId = res.data
        app.goPay({
          orderId: orderId,
          successUrl: '/myIntegral'
        });
      },
      fail: function() {
        that.setIsPaying(false)
      },
      complete: function() {
        that.setIsPaying(false)
      }
    })
  }
  // 设置是否在付款中
  setIsPaying = bool => {
    this.payLoading = bool
    this.setData({
      isPaying: bool
    })
  }
  // 默认选中
  defaultSelect = data => {
    let newData = {
      currentTarget: {
        dataset: {
          index: 0
        }
      }
    }
    if (this.data.storedId) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].id == this.data.storedId) {
          newData.currentTarget.dataset.index = i
        }
      }
    }
    this.selectActiveItem(newData)
  }
  // 跳转到充值记录
  turnToRecords = () => {
    app.turnToPage('/eCommerce/pages/myIntegral/myIntegral')
  }

  render() {
    const {
      canUseIntegral,
      itemList,
      type,
      selectedItem,
      customItemInfo,
      couponItemList,
      selectedCouponItem,
      isPaying
    } = this.state
    return (
      // TODO: 获取个人信息组件弹窗
      <div className="recharge-wrap page" id="recharge">
        <div className="recharge-wrap-content">
          <div className="stored-value-header">
            <div className="stored-value-content">
              <div className="stored-value-num">{canUseIntegral}</div>
              <div className="stored-value-describe">当前积分</div>
            </div>
            <div
              className="stored-value-record"
              onClick={this.turnToRecords}
            >
              充值记录
            </div> 
          </div>
          {(itemList.length > 0 || customItemInfo.status == 1) && (
            <div className="select-area">
              <div className="select-list">
                {itemList.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={
                        'select-item ' +
                        (type == 1 && selectedItem.index == index
                          ? 'active'
                          : '')
                      }
                      data-index={index}
                      onClick={this.selectActiveItem}
                    >
                      <div
                        className={
                          'recharge-money ' +
                          (type == 1 && selectedItem.index == index
                            ? 'active'
                            : '')
                        }
                      >
                        {item.rechargeMoney + '元'}
                      </div>
                      <div
                        className={
                          'give-money ' +
                          (type == 1 && selectedItem.index == index
                            ? 'active'
                            : '')
                        }
                      >
                        {item.rechargeNum + '分'}
                      </div>
                    </div>
                  )
                })}
              </div>
              {/* {customItemInfo.status == 1 && (
                <div
                  className={'custom-item ' + (type == 6 ? 'active' : '')}
                  onClick={this.selectCustomItem}
                >
                  <div className="item-title">自定义金额</div>
                  <div className="item-price-block">
                    <span className="item-price-symbol">¥</span>
                    <input
                      className="item-price-input"
                      type="digit"
                      placeholder="请输入金额"
                      // placeholderStyle="color: #999999;"
                      onFocus={this.selectCustomItem}
                      onBlur={this.confirmCustomPrice}
                      onInput={this.confirmCustomPrice}
                    ></input>
                  </div>
                  {customItemInfo.tip && (
                    <div className="item-tip">{customItemInfo.tip}</div>
                  )}
                </div>
              )} */}
            </div>
          )}
          {itemList.length == 0 && customItemInfo.status != 1 && (
            <div className="recharge-no-data">
              <img
                className="no-data-image"
                src="http://cdn.jisuapp.cn/static/webapp/images/stored-value/none-stored-record.png"
              />
              <div>暂无可充值选项</div>
            </div>
          )}
        </div>
        {(itemList.length > 0 ||
          customItemInfo.status == 1 ||
          couponItemList.length > 0) && (
          <div className="recharge-bottom">
            <div className="stored-value-form">
              <button
                className="recharge-btn"
                onClick={this.gotoRecharge}
                disabled={isPaying}
              >
                充值
              </button>
            </div>
          </div>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/official-page/recharge-integral/RechargeIntegral.jsx